// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"Y6-z"};